function sorguDizgesi(sorgu) {
    const params = new URLSearchParams();
    if (sorgu.sayfa)
        params.set('sayfa', String(sorgu.sayfa));
    if (sorgu.boyut)
        params.set('boyut', String(sorgu.boyut));
    if (sorgu.arama)
        params.set('arama', sorgu.arama);
    if (sorgu.aktif !== undefined)
        params.set('aktif', String(sorgu.aktif));
    const s = params.toString();
    return s ? `?${s}` : '';
}
export async function musterileriListele(istemci, sorgu = {}) {
    return istemci.istek(`/musteriler${sorguDizgesi(sorgu)}`);
}
export async function musteriGetir(istemci, id) {
    return istemci.istek(`/musteriler/${id}`);
}
//# sourceMappingURL=musteriler.js.map